/**
 * HeroSection - Trial badge and main headline
 *
 * Mobile: Trial badge with lock icon on right, headline with "Take control" in orange
 * Desktop: Same but without lock icon (it's in header)
 */

interface HeroSectionProps {
  /** Whether to show trial badge */
  isTrial?: boolean;
}

export function HeroSection({ isTrial = true }: HeroSectionProps) {
  return (
    <div className="flex flex-col gap-1">
      {/* Trial badge row with lock icon */}
      <div className="flex items-center justify-between py-3">
        {isTrial && (
          <div className="inline-flex rounded bg-catch-avocado-400 px-3 py-1">
            <span className="text-xs font-bold tracking-wider text-catch-dark-blue-90">
              7-Day Free Trial
            </span>
          </div>
        )}

        {/* Lock icon - mobile only */}
        <div className="flex items-center justify-center rounded-full bg-slate-100 p-2 lg:hidden">
          <svg
            className="h-3.5 w-3.5 text-catch-dark-blue-90"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 6.5H3C2.72386 6.5 2.5 6.72386 2.5 7V12C2.5 12.2761 2.72386 12.5 3 12.5H11C11.2761 12.5 11.5 12.2761 11.5 12V7C11.5 6.72386 11.2761 6.5 11 6.5Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.5 6.5V4C4.5 3.33696 4.76339 2.70107 5.23223 2.23223C5.70107 1.76339 6.33696 1.5 7 1.5C7.66304 1.5 8.29893 1.76339 8.76777 2.23223C9.23661 2.70107 9.5 3.33696 9.5 4V6.5"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>

      {/* Main headline - "Take control" in salmon/coral, rest in dark blue */}
      <h1 className="text-[30px] font-bold leading-[1.3] lg:text-5xl">
        <span className="text-catch-salmon">Take control</span>
        <span className="text-catch-dark-blue-90"> of your cancer risk.</span>
      </h1>

      {/* Subheadline */}
      <p className="text-sm leading-relaxed text-slate-500 lg:text-lg">
        No more guessing, no more spiraling. Just a clear, science-backed plan
        that puts your health in your hands.
      </p>
    </div>
  );
}

export default HeroSection;
